<template>
  <a
    @click="toggleNav()"
    :class="{ 'navbar-burger': true, burger: true, 'is-active': activeNav }"
    role="button"
    aria-label="menu"
    aria-expanded="false"
  >
    <span aria-hidden="true"></span> <span aria-hidden="true"></span>
    <span aria-hidden="true"></span>
  </a>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'HeaderHamburger',
  model: {
    event: 'toggleNav'
  },
  methods: {
    ...mapActions(['toggleNav'])
  },
  computed: {
    ...mapGetters(['activeNav'])
  }
};
</script>

<style lang="scss" scoped></style>
